"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var shop_badges_1 = require("./shop_badges");
var star_rating_1 = require("./star_rating");
var core_link_1 = require("./core_link");
var url_helpers_1 = require("../url_helpers");
var SellerInfo = /** @class */ (function (_super) {
    tslib_1.__extends(SellerInfo, _super);
    function SellerInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SellerInfo.prototype.renderShopName = function () {
        var _a = this.props.shop, name = _a.name, slug = _a.slug;
        if (!this.props.linkShop)
            return name;
        return (React.createElement(core_link_1.default, { to: url_helpers_1.SHOP_PATH.expand({ slug: slug }) }, name));
    };
    SellerInfo.prototype.renderShopBadges = function () {
        var _a = this.props.shop, preferredSeller = _a.preferredSeller, quickResponder = _a.quickResponder, quickShipper = _a.quickShipper;
        return (React.createElement(shop_badges_1.default, { preferredSeller: preferredSeller, quickShipper: quickShipper, quickResponder: quickResponder }));
    };
    SellerInfo.prototype.render = function () {
        if (!this.props.shop || !this.props.shop.user) {
            return (React.createElement("div", { className: "seller-info" }));
        }
        var _a = this.props.shop.user.feedbackSummary, receivedCount = _a.receivedCount, rollingRatingPercentage = _a.rollingRatingPercentage;
        var rating = rollingRatingPercentage / 100;
        return (React.createElement("div", { className: "seller-info" },
            React.createElement("div", { className: "seller-info__name" }, this.renderShopName()),
            React.createElement("div", { className: "seller-info__location" }, this.props.shop.address.displayLocation),
            React.createElement("div", { className: "seller-info__rating" },
                React.createElement(star_rating_1.default, { rating: rating, count: receivedCount })),
            React.createElement("div", { className: "seller-info__badges" }, this.renderShopBadges())));
    };
    return SellerInfo;
}(React.Component));
exports.default = SellerInfo;
//# sourceMappingURL=seller_info.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/seller_info.js
// module id = lw5e
// module chunks = 0 1 2 3 4 6 8 11 12 13 20